import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import DataHelper, { DataHelperConfiguration } from "@Scripts/Common/DataHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "MyNotificationInfo" })
export default class MyNotificationInfo extends Vue {
    public localizer: any = Localizer;
    public dataConfiguration: DataHelperConfiguration = { culture: (<any>window).App.userCulture };

    @Prop() readonly notification: any;

    public getValue(name: string): string {
        let value: string = null;

        let items = this.notification.notificationValues.filter(x => x.name === name);
        if (items.length !== 0) {
            value = items[0].value;
        }

        return value;
    }

    public openLink(linkUrl: string) {
        if (linkUrl) {
            this.setIsRead();

            if (this.isAbsoluteUrl(linkUrl)) {
                window.open(linkUrl, "_blank");
            } else {
                window.location.href = linkUrl;
            }
        }
    }

    public setIsRead() {
        if (!this.notification.isReadDisabled) {
            this.$emit("setIsRead", this.notification);
        }
    }

    public convertToLocalDate(utcDate: string): string {
        return DataHelper.convertDateToString(utcDate, this.dataConfiguration, true, false);
    }

    public isAbsoluteUrl(url: string): boolean {
        return new RegExp('^(?:[a-z]+:)?//', 'i').test(url);
    }
};